import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { GlobalErrorHandler } from './core/global-error-handler';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthIInterceptor } from 'src/auth/auth-i.interceptor';
import { nmiBranchInterceptorFn } from './interceptors/nmi-branch.interceptor';

import { provideNmi, nmiAuthInterceptorFn } from '@cmbsolutions/nmi-angular';
import store from 'store2';
import { environment } from 'src/environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([AuthIInterceptor, nmiBranchInterceptorFn, nmiAuthInterceptorFn])),
    ...provideNmi({
      apiUrl: environment.nmiApiUrl,
      tokenFn: () => store.get('token') as string,
      branchId: () => store.get('userbranches') as string,
    }),
  ]
};
